import { GfsCalculationListPage } from "@/services/backend/gfs/calculation/components/calculation-list-page";

export default function GfsCalculationsIndexRoute() {
  return <GfsCalculationListPage />;
}
